<template>
	<div>
		<div id="d21-cancellation">
			<div class="d21-block">
				<div class="mdl-grid d21-contact-checkout">
					<div class="mdl-cell mdl-cell--12-col" v-if="!isCancelled">
						<i class="material-icons d21-cancellation-question">help_outline</i>
						{{ T("cancellation_question") }}<br />
						<span class="d21-cancellation-hint">{{ T("cancellation_question_hint") }}</span><br />
						<button class="btn btn-primary" v-on:click="onCancel" v-if="isCancellable">
							<span>{{ T("oneticketing_cancel") }}</span>
						</button>
						<div class="d21-cancellation-error" v-if="isCancellable !== null && errorMessage !== null">{{ T(errorMessage) }}</div>
					</div>
					<div class="mdl-cell mdl-cell--12-col" v-else>
						<i class="material-icons">check_circle</i>
						{{ T("Cancellation_done") }}<br />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from "moment";
	import baseMixin from "../mixins/base";
	import Vue from 'vue';
	import Variables from "../scripts/_variables.js";
	import _hub from '../scripts/_hub';
	import {
		EventBus
	} from "../scripts/_eventBus.js";

	export default {
		mixins: [baseMixin],
		components: {},
		name: "d21-cancellation",
		computed: {},
		data() {
			return {
				isCancelled: false,
				isCancellable: null,
				errorMessage: null
			}
		},
		created() {
			EventBus.$on("channel_loaded", this.onChannelLoaded);
		},
		methods: {
			onChannelLoaded() {
				let command = `/book/isCancellable/${this.$route.params.channel}/${this.$route.params.code}`;
				this.apiRequest(command, null, "GET", response => {
					if (response && response.Value) {
						this.errorMessage = null;
						this.isCancellable = true;
					} else {
						this.errorMessage = response.Meta.Message;
						this.isCancellable = false;
					}
				});
			},
			onCancel() {
				let command = `/book/cancel/${this.$route.params.channel}/${this.$route.params.code}`;
				this.apiRequest(command, null, "GET", response => {
					if (response && response.Value) {
						this.errorMessage = null;
						this.isCancelled = true;
					} else {
						this.errorMessage = response.Meta.Message;
						this.isCancelled = false;
					}
				});
			}
		}
	}
</script>